module.exports = __webpack_public_path__ + "static/media/thumbnails for website-07.7337d029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/thumbnails/thumbnails for website-07.jpg
// module id = 264
// module chunks = 1